const categoryKey = employee => employee?.category_id || null;

export const reorderEmployeeWithinCategory = (employees, draggedId, targetId) => {
  const draggedEmployee = employees.find(employee => employee.id === draggedId);
  const targetEmployee = employees.find(employee => employee.id === targetId);

  if (
    !draggedEmployee
    || !targetEmployee
    || draggedId === targetId
    || categoryKey(draggedEmployee) !== categoryKey(targetEmployee)
  ) {
    return { employees, changed: false };
  }

  const groupSlots = employees
    .map((employee, index) => ({ employee, index }))
    .filter(({ employee }) => categoryKey(employee) === categoryKey(draggedEmployee));
  const groupEmployees = groupSlots.map(({ employee }) => employee);
  const fromIndex = groupEmployees.findIndex(employee => employee.id === draggedId);
  const toIndex = groupEmployees.findIndex(employee => employee.id === targetId);
  const [movedEmployee] = groupEmployees.splice(fromIndex, 1);
  groupEmployees.splice(toIndex, 0, movedEmployee);

  const reordered = [...employees];
  groupSlots.forEach(({ index }, groupIndex) => {
    reordered[index] = groupEmployees[groupIndex];
  });

  return {
    employees: reordered.map((employee, sort_order) => ({ ...employee, sort_order })),
    changed: true,
  };
};

export const persistEmployeeOrder = async (previous, next, save) => {
  try {
    const employees = await save(next.map(employee => employee.id));
    return { employees, error: null };
  } catch (error) {
    return { employees: previous, error };
  }
};
